import React from "react";

const DisplayLayout = ({ mainBg, footerBg, customFooter = "", children }) => {
  return (
    <main
      className="w-full min-h-screen relative rounded-25 overflow-hidden"
      style={{ backgroundColor: mainBg }}
    >
      <div className="ksm:pt-[8%]  ksm:px-[10%]  flex justify-center">
        {children}
      </div>
      <div
        className="bg-no-repeat bg-center bg-cover absolute top-0 left-0 rounded-t-25 w-full h-[25%]"
        style={{ backgroundImage: `url('/images/static/islamic-bg.svg')` }}
      ></div>

      {customFooter ? (
        customFooter()
      ) : (
        <div
          className="absolute bottom-0 z-20 left-0 rounded-25 w-full h-[25%]"
          style={{ backgroundColor: footerBg }}
        ></div>
      )}
    </main>
  );
};

export default DisplayLayout;
